import React from "react";
import { Link } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import { resolveCmsAsset } from "../cms/media";
import { useCmsPage } from "../cms/useCmsContent";
import BlockRenderer from "../components/blocks/BlockRenderer";

function imageSrc(path) {
  return resolveCmsAsset(path);
}

export default function AboutPage() {
  const { content } = useCmsPage("about");
  const blocks = content.blocks || [];

  if (blocks.length > 0) {
    return (
      <div>
        <BlockRenderer blocks={blocks} />
      </div>
    );
  }

  const sections = content.sections || {};
  const hero = sections.hero || {};
  const stats = sections.stats || [];
  const contentBlocks = sections.blocks || [];

  return (
    <div>
      <header className="pt-10 text-center col-12 col-sm-9 col-lg-7 col-xl-6 mx-auto">
        <h1 className="section-heading mx-auto mb-3">{hero.title}</h1>
        <p className="text-muted lead mb-0">{hero.description}</p>
      </header>
      <div className="container py-7">
        <div className="row g-3">
          <div className="col-12 d-none d-md-block">
            <div className="row g-3">
              {["/assets/images/rabat.jpg", "/assets/images/abidjan.jpg", "/assets/images/paris.jpg"].map(
                (image) => (
                  <div className="col-12 col-md-4" key={image}>
                    <picture>
                      <img
                        className="img-fluid rounded shadow-sm"
                        src={imageSrc(image)}
                        alt="Fatihoune"
                      />
                    </picture>
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        <div className="col-12 col-md-8 col-lg-6 mx-auto text-center py-4 border-bottom mb-5">
          <div className="my-5 d-none d-md-flex align-items-start justify-content-between">
            {stats.map((stat) => (
              <div key={`${stat.value}-${stat.label}`}>
                <span className="display-3 fw-bold text-primary d-block">
                  {stat.value}
                </span>
                <span className="d-block fs-9 fw-bolder tracking-wide text-uppercase text-muted">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {contentBlocks.map((block, index) => {
          const copy = (
            <div className="col-12 col-lg-6">
              <h2 className="section-heading mb-4">{block.title}</h2>
              {block.text && <p>{block.text}</p>}
              {block.items?.length > 0 && (
                <ul>
                  {block.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          );
          const visual = (
            <div className="col-12 col-lg-6">
              <picture>
                <img
                  className="img-fluid rounded shadow-sm"
                  src={imageSrc(block.image)}
                  alt={block.imageAlt || block.title}
                />
              </picture>
            </div>
          );

          return (
            <div className="py-6 row gx-8 align-items-center" key={block.title}>
              {index % 2 === 0 ? (
                <>
                  {copy}
                  {visual}
                </>
              ) : (
                <>
                  {visual}
                  {copy}
                </>
              )}
            </div>
          );
        })}

        <div className="d-flex justify-content-center my-5">
          <div className="rounded-pill border px-5 py-3 text-muted d-flex align-items-center">
            Vous souhaitez rejoindre notre équipe ?
            <Link to="/contact" className="fw-bold d-flex align-items-center ms-2">
              Nous recrutons <RiArrowRightLine className="ms-1" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
